exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nspan.fa[data-v-25d70e21] {\n  color: #fff;\n}\n.group-box[data-v-25d70e21] {\n  cursor: pointer;\n}\n.dropdownMenuButton[data-v-25d70e21] {\n  background-color:white;\n}\n.info-box-number[data-v-25d70e21] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.small-title[data-v-25d70e21] {\n  font-size: 25px;\n}\n.small-margin-text[data-v-25d70e21] {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.no-padding-box[data-v-25d70e21] {\n  padding: 0px;\n  padding-left: 0px;\n  min-height: 70px;\n}\n.btn-transparent[data-v-25d70e21] {\n  background-color: transparent;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-25d70e21","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/groups-v2/cards/GroupCard.vue
// module id = 915
// module chunks = 1